/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
/* ESC Variant selector form update NBIS */

$( ".Popover__Value" ).click(function() {
         window.esc_now_back_in_stock.triggerRefresh()
      });

$('.dynamic-add-to-cart').on('click', function (){
  addItemToCart($(this).data('variant-id'), 1)
})

function addItemToCart(variant_id, qty, frequency, unitType) {
  let data = {
    "id": variant_id,
    "quantity": qty
  };

  if (frequency) {
    data.properties = {
      "shipping_interval_frequency": frequency,
      "shipping_interval_unit_type": unitType
    }
  }

  // console.log('add in this', data);

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function () {
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: variant_id,
          quantity: qty
        }
      }));
    }
  });
}   
